import React, { useEffect, useState } from 'react';
import { ECMID } from '../../../constants';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumb from '../../../component/Breadcrumb';
import { Grid, Typography, Box, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import swal from 'sweetalert';
import FormNumberField from '../../../component/NumberInput';

const AddNewConstant = () => {
    const location = useLocation();
    const [fields,setFields] = useState({
        ECMID    : '',
        Priority : '',
        PGN      : '',
        PGNLen   : 8,
        Byte1    : 255,
        Byte2    : 255,
        Byte3    : 255,
        Byte4    : 255,
        Byte5    : 255,
        Byte6    : 255,
        Byte7    : 255,
        Byte8    : 255,
        TrigAddr : '',
        ReTxRate : '',
        Desc     : ''
    })


    useEffect(()=> {
        if(location.state?.rowId !== '' && location.state?.rowId !== undefined){

            let existingConstantMessages = JSON.parse(localStorage.getItem('ECUConstantTxMessages'));
            setFields(existingConstantMessages[location.state?.rowId])
        }
    },[location.state?.rowId])

    const handleBlurUpdate = (name,value) => {
        let finalVal;
        if(name === 'ReTxRate') {
            const result = decimalValidation(name,value);
            if(result){
                swal("Oops!", "Please use Float value for ReTxRate!", "error");
            }
            if(value % 1 === 0){
                value = Number(value) === 0 ? 0.000001 : parseFloat(value) + 0.000001;
            }
            finalVal = value ? parseFloat(value) : '';
        } else {
            finalVal = parseInt(value);
        }
        
        setFields((prevState) => ({...prevState, [name]: finalVal}));
        //setFields((prevState) => ({...prevState, [name]: isNaN(parseFloat(value)) ? '' : parseFloat(value)}));
    } 

    const changeHandler = (e) => {
        let value = e.target.name === 'ECMID' || e.target.name === 'Desc' ? e.target.value :  e.target.value.replace(/\D/g, "");
        let name  = e.target.name;
        setFields((prevState) => ({...prevState, [name]: e.target.name === 'Desc' ? value : isNaN(parseInt(value)) ? '' : parseInt(value)}))
    }

    const decimalValidation = (name,value) => {
        let validationArray = ['ReTxRate'];
        if(validationArray.includes(name) && value !== '' && value?.toString()?.indexOf('.') === -1) {
            return true;
        } 
        return false;
    }

    const handleSubmit = () => {
        const isEmpty = !Object.values(fields).every(val => val !== null && val !== '');
        if(isEmpty){
            swal("Oops!", "Please fill required fields!", "error");
            return false;
        }

        let valdationStatus = false;
        Object.keys(fields).forEach(function(key) {
            const result = decimalValidation(key,fields[key]);
            if(result){
                valdationStatus = true;
            }        
        });

        if(valdationStatus){
            swal("Oops!", "Please use Float value for ReTxRate!", "error");
            return false;
        }

        if(location.state?.rowId !== '' && location.state?.rowId !== undefined){
            let existingConstantMessages = JSON.parse(localStorage.getItem('ECUConstantTxMessages'));
            existingConstantMessages[location.state?.rowId] = fields;
            localStorage.setItem('ECUConstantTxMessages',JSON.stringify(existingConstantMessages));
            swal({
                title: "Success",
                text: 'ECU Constant TxMessages updated successfully.',
                icon: "success",
            })
        } else {
            let existingConstantMessages = JSON.parse(localStorage.getItem('ECUConstantTxMessages'));
            if(existingConstantMessages == null) existingConstantMessages = [];
            existingConstantMessages.push(fields);
            localStorage.setItem('ECUConstantTxMessages',JSON.stringify(existingConstantMessages));
            swal({
                title: "Success",
                text: 'ECU Constant TxMessages added successfully.',
                icon: "success",
            })
            setFields({
                ECMID    : '',
                Priority : '',
                PGN      : '',
                PGNLen   : 8,
                Byte1    : 255,
                Byte2    : 255,
                Byte3    : 255,
                Byte4    : 255,
                Byte5    : 255,
                Byte6    : 255,
                Byte7    : 255,
                Byte8    : 255,
                TrigAddr : '',
                ReTxRate : '',
                Desc     : ''
            })
        }
    }

    return (
        <>
            <Breadcrumb title={location.state?.rowId !== '' &&  location.state?.rowId !== undefined ? 'Edit' : 'Add New' }>
                <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
                    Dashboard
                </Typography>
                <Typography component={Link} to={location.pathname.includes('mapping') ? '/mapping/can/constant-messages' : '/can/constant-messages'} variant="subtitle2" color="primary" className="link-breadcrumb">
                    ECUConstantTxMessages
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                {location.state?.rowId !== '' &&  location.state?.rowId !== undefined ? 'Edit' : 'New' }
                </Typography>
            </Breadcrumb>
            <Box component="section">
                <Grid className="contentBox">

                    <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                        <Grid item>
                            <Button
                                component={Link} 
                                to={location.pathname.includes('mapping') ? '/mapping/can/constant-messages' : '/can/constant-messages'}
                                variant="contained"
                                size="small"
                                color="primary"
                                sx={{mr:3}}
                            >Back 
                            </Button>
                        </Grid>
                    </Grid>
                    
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormControl
                                margin="dense"
                                fullWidth
                            >
                                <InputLabel id="demo-simple-select-standard-label">ECMID</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    sx={{
                                        "&:focus": {
                                            backgroundColor: "#ffffff"
                                        }
                                    }}
                                    label="ECMID"
                                    value={fields.ECMID}
                                    onChange={changeHandler}
                                    name="ECMID"
                                    error={fields.ECMID === ""}
                                >
                                    <MenuItem value="">Select ECMID</MenuItem>
                                    {ECMID?.map((opt) => (
                                        <MenuItem key={opt.value} value={opt.value}>{opt.name}</MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText sx={{color:"#d32f2f"}} >{fields.ECMID === "" ? "Required Field!" : false}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="Priority"
                                label="Priority"
                                name="Priority"
                                value={fields.Priority}
                                onChange={changeHandler}
                                error={fields.Priority === ""}
                                helperText={fields.Priority === "" ? "Required Field!" : false}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="PGN"
                                label="PGN"
                                name="PGN"
                                value={fields.PGN}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="PGNLen"
                                label="PGNLen"
                                name="PGNLen"
                                value={fields.PGNLen}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="Byte1"
                                label="Byte1"
                                name="Byte1"
                                value={fields.Byte1}
                                onChange={changeHandler}
                                error={fields.Byte1 === ""}
                                helperText={fields.Byte1 === "" ? "Required Field!" : false}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="Byte2"
                                label="Byte2"
                                name="Byte2"
                                value={fields.Byte2}
                                onChange={changeHandler}
                                error={fields.Byte2 === ""}
                                helperText={fields.Byte2 === "" ? "Required Field!" : false}
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                //sx={{mt: { xs:'24px',sm:'8px',md:'8px'}}}
                                fullWidth
                                margin="dense"
                                id="Byte3"
                                label="Byte3"
                                name="Byte3"
                                value={fields.Byte3}
                                onChange={changeHandler} 
                                error={fields.Byte3 === ""}
                                helperText={fields.Byte3 === "" ? "Required Field!" : false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="Byte4"
                                label="Byte4"
                                name="Byte4"
                                value={fields.Byte4}
                                onChange={changeHandler}
                                error={fields.Byte4 === ""}
                                helperText={fields.Byte4 === "" ? "Required Field!" : false}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="Byte5"
                                label="Byte5"
                                name="Byte5"
                                value={fields.Byte5}
                                onChange={changeHandler}
                                error={fields.Byte5 === ""}
                                helperText={fields.Byte5 === "" ? "Required Field!" : false}
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                //sx={{mt: { xs:'24px',sm:'8px',md:'8px'}}}
                                fullWidth
                                margin="dense"
                                id="Byte6"
                                label="Byte6"
                                name="Byte6"
                                value={fields.Byte6}
                                onChange={changeHandler} 
                                error={fields.Byte6 === ""}
                                helperText={fields.Byte6 === "" ? "Required Field!" : false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="Byte7"
                                label="Byte7"
                                name="Byte7"
                                value={fields.Byte7}
                                onChange={changeHandler}
                                error={fields.Byte7 === ""}
                                helperText={fields.Byte7 === "" ? "Required Field!" : false}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="Byte8"
                                label="Byte8"
                                name="Byte8"
                                value={fields.Byte8}
                                onChange={changeHandler}
                                error={fields.Byte8 === ""}
                                helperText={fields.Byte8 === "" ? "Required Field!" : false}
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="TrigAddr"
                                label="TrigAddr"
                                name="TrigAddr"
                                value={fields.TrigAddr}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                        <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="ReTxRate"
                                label="ReTxRate"
                                name="ReTxRate"
                                value={fields.ReTxRate}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="float"
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={12} md={12}>
                            <TextField
                               // sx={{mt: { xs:'24px',sm:'8px',md:'8px'}}}
                                fullWidth
                                margin="dense"
                                id="Desc"
                                label="Desc"
                                name="Desc"
                                value={fields.Desc}
                                multiline
                                rows={4}
                                onChange={changeHandler}
                                error={fields.Desc === ""}
                                helperText={fields.Desc === "" ? "Required Field!" : false}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <Grid container direction="row" spacing={1} display={'flex'} justifyContent={'flex-start'}>
                            <Grid item>
                                <Button
                                    onClick={handleSubmit}
                                    variant="contained"
                                    size="medium"
                                    color="primary"
                                    sx={{mt:2}}
                                >Submit
                                </Button>
                            </Grid>
                            <Grid item >
                                <Button
                                    component={Link} 
                                    to={location.pathname.includes('mapping') ? '/mapping/can/constant-messages' : '/can/constant-messages'}
                                    variant="contained"
                                    size="medium"
                                    color="error"
                                    sx={{mt:2}}
                                >Cancel
                                </Button>
                            </Grid>
                        </Grid> 
                    </Grid> 
                </Grid>
            </Box>
        </>
    );
};

export default AddNewConstant;
